import React, { Component } from 'react';
import standard_abi from '../abis/Standard16A-abi.json';
import Web3 from 'web3';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { properties } from './properties.js';
import { withTranslation } from 'react-i18next';
import i18n from './I18N/I18n.js'; 
import { logout, apiSecuredRequest, setBearer, isUserOrWallet, isRootWallet, cargarIdiomaPreferido} from './functions.js';

import './css/privateKey.css';
import NavBar from './navbar.js';
import Footer from './footer.js';
import UsuarioDisplay from './UsuarioDisplay.js';
import CountrySelect from './CountrySelect.js';



class PrivateKeyGenerator extends Component {

    async componentDidMount() {
        // 1. Carga de Web3
        await cargarIdiomaPreferido(this.cambiarIdioma);
        const bearer = await this.checkIfWeb3UserOrLoginUser();
        await this.cargarCamposMarca(bearer);
       
        // 2. Carga de datos de la Blockchain

      //  await this.cargarCamposMarca()
    }

    cambiarIdioma = (idioma) => {
        const { i18n } = this.props;
        i18n.changeLanguage(idioma); 
        this.forceUpdate(); 
        Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
      };

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

    async checkIfWeb3UserOrLoginUser() { 
        let params = (new URL(document.location)).searchParams;
        const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})
        
        const standardType = params.get("standardType");
        this.setState({ standardType: standardType })
        const email = Cookies.get("email");
        this.setState({ email: email });
        const certificado = JSON.parse(localStorage.getItem('certificado'));
        const usuario = JSON.parse(localStorage.getItem('usuario'));
        this.setState({userId: usuario.id})
        const direccion = certificado.direccion;
        this.setState({direccion: direccion})
        const bearer = Cookies.get("id");
        this.setState({ bearer: bearer });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        
        bearerVar = Cookies.get("id");
        let account = await isUserOrWallet(email, bearerVar);
        const isRootDir = await isRootWallet(account);
        this.setState({isRootDir: isRootDir});

        this.setState({account})
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
        return bearerToken;
    }

    async cargarCamposMarca(bearer) {
        localStorage.removeItem('campos');

        var camposData

        if (this.state.standardType == "8") {
            camposData = JSON.stringify({
                "certificadoId": `${this.state.certificadoId}`,
                "tipoStandard": `8CAMPOS`
            });

        } else if (this.state.standardType == "16") {

            camposData = JSON.stringify({
                "certificadoId": `${this.state.certificadoId}`,
                "tipoStandard": `16CAMPOS`
            });

        } else if (this.state.standardType == "24") {
            camposData = JSON.stringify({
                "certificadoId": `${this.state.certificadoId}`,
                "tipoStandard": `24CAMPOS`
            });

        }


        let campos;

                try {
                    campos = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/campo/getCampos`, camposData, bearer);
                } catch (error) {
                    console.error("Error al obtener los campos:", error);

                    Swal.fire({
                        title: `${i18n.t('errorOccurred')}`,
                        confirmButtonText: `${i18n.t('continue')}`,
                        confirmButtonColor: '#E94981',
                        icon: 'error',
                        iconColor: '#66C08B',
                        width: '560px',
                    });

                    campos = {}; 
                }

        localStorage.setItem('campos', JSON.stringify(campos.data));  
        this.setState({ campos: campos.data })
        
    }

    handleCountryChange = async (newCountry) => {
        const nuevoCodigoPais = event.target.value;
        this.setState({ selectedCountry: newCountry });
     

        try {
            let response;
            if(nuevoCodigoPais == "" || newCountry != nuevoCodigoPais){
                response = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/usuario/getLanguajesByCodigoPais/${newCountry}`, "", this.state.bearer);
                this.setState({codigoPais: newCountry });
                
            }else {
                response = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/usuario/getLanguajesByCodigoPais/${nuevoCodigoPais}`, "", this.state.bearer);
                 this.setState({codigoPais: newCountry });
            }
            
            if (response.data && response.data.length > 1) {
                this.setState({multiLanguajeCountry: "true"});
                this.setState({idiomasDisponibles: response.data})
                console.log("Más de un idioma recibido:", response.data);
            } else if (response.data.length == 1) {
                this.setState({multiLanguajeCountry: "false"});
                
            } else {
                console.log("No se recibieron idiomas.");
            }
        } catch (error) {
            // Manejar errores aquí
            console.error("Error al obtener los idiomas:", error);
            Swal.fire({
                title: `${i18n.t('errorOccurred')}`,
                confirmButtonText: `${i18n.t('continue')}`,
                confirmButtonColor: '#E94981',
                icon: 'error',
                iconColor: '#66C08B',
                width: '560px',
            });
        }
    };

    _checkIfInfoCorrect = async (nombre, apellido1, apellido2, email, id, idProducto, ownerAddress, codigoPais, codigoLetras) => {
        const idProductoNombre = this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")[0]

        if (nombre != "" && apellido1 != "" && email != "" && idProducto != "" && ownerAddress != "" && id != "") {
            Swal.fire({
                icon: 'question',
                iconColor: "#66C08B",
                title: `${i18n.t('iscorrect')}`,
                showDenyButton: true,
                html: `
                               <style>
                    table {
                        width: 100%; /* Ensures the table uses the full width of the alert */
                        border-collapse: collapse; /* Neatly joins the borders */
                        background: #f8f8f8; /* Gives a subtle background color */
                        border-radius: 8px; /* Rounded corners for the table */
                        overflow: hidden; /* Ensures the border-radius clips the content */
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow around the table */
                    }
                    th, td {
                        padding: 12px 15px; /* Ample padding for table cells */
                        border-bottom: 1px solid #ddd; /* Light line below each row */
                    }
                    th {
                        background-color: #e94981; /* Vibrant pinkish-magenta background for the header */
                        color: white; /* White text for better readability */
                        font-size: 16px; /* Slightly larger text for headings */
                    }
                    td {
                        color: #333; /* Darker text color for better readability */
                        font-size: 14px; /* Standard text size */
                    }
                    tr:last-child td {
                        border-bottom: none; /* Removes border from the last row */
                    }
                    td:first-child {
                        text-align: right; /* Aligns the labels to the right */
                        font-weight: bold; /* Makes the labels bold */
                        background-color: #f0f0f0; /* Light grey background for labels */
                    }
                    td:last-child {
                        text-align: left; /* Ensures values are aligned to the left */
                        background-color: #f7f7f7; /* Lighter grey background for values, enhancing contrast */
                    }
                </style>

            <table class="cewy-table">
            <thead>
                <tr>
                <th colspan="2">${i18n.t('userInfo')}</th>
                </tr>
            </thead>
            <tbody>
                <tr><td>${i18n.t('name')}:</td><td>${nombre}</td></tr>
                <tr><td>${i18n.t('apellido1')}:</td><td>${apellido1}</td></tr>
                <tr><td>${i18n.t('apellido2')}:</td><td>${apellido2}</td></tr>
                <tr><td>${i18n.t('email')}:</td><td>${email}</td></tr>
                <tr><td>${i18n.t('documento')}:</td><td>${id}</td></tr>
                <tr><td> ${i18n.t(this.state.campos.filter((campo) => campo.orden == "IDPRODUCTO")[0].nombreCampo)}:</td><td>${idProducto}</td></tr>
                <tr><td>${i18n.t('propietarioCarpeta')}:</td><td>${ownerAddress}</td></tr>
                 <tr><td>${i18n.t('country')}:</td><td>${codigoLetras}</td></tr>
            </tbody>
            </table>
                        `,
                confirmButtonText: `${i18n.t('generatePrimaryKey')}`,
                denyButtonText: `${i18n.t('makeChanges')}`,
                confirmButtonColor: "#E94981",
                // denyButtonColor: "#F07577",
                width: '750px',
            })
                .then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {

                        this._createUserIfNotExists(nombre, apellido1, apellido2, email, id, ownerAddress, idProducto, this.state.isChecked, codigoPais)


                    } else if (result.isDenied) {
                        Swal.fire({
                            title: `${i18n.t('changesNotSaved')}`,
                            confirmButtonText: `${i18n.t('Continue')}`,
                            confirmButtonColor: '#E94981',
                            icon: 'info',
                            iconColor: '#66C08B',
                            width: '560px',
                        })
                    }
                })
        } else {
            Swal.fire({
                title: `${i18n.t('missingFields')}`,
                text: '',
                icon: 'error',
                confirmButtonText: 'Back',
                confirmButtonColor: "#E94981",
            })
        }

    }


    _encryptUserInfo = async (nombre, apellido1, apellido2, documento, email, idProducto, ownerAddress) => {
        
        this.setState({userEmail: email});


        try {
            const web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
            const abi = standard_abi;
            const certificado = JSON.parse(localStorage.getItem('certificado'));
            const direccion = certificado.direccion;
            if(abi && direccion){
                const contract = new web3.eth.Contract(abi, direccion);
                this.setState({ contract })
                const userInfo = await contract.methods.createUserInfo(nombre, apellido1, apellido2, email, documento, 
                    idProducto,
                    ownerAddress).call({ from: properties.contractOwner})

                    const userData = {
                        nombre,
                        apellido1,
                        apellido2,
                        email,
                        documento,
                        idProducto,
                        ownerAddress, 
                        isChecked: this.state.isChecked 
                        
                    };
                    
                    // Guardar el objeto como JSON en localStorage
                localStorage.setItem('userData', JSON.stringify(userData));
                
                this.setState({ userInfo })
                this.setState({ idProducto })
                this.setState({ ownerAddress })
                Swal.fire({
                    icon: 'success',
                    title: `${i18n.t('privateKeyGeneratedSuccessfully')}`,
                    text: `${userInfo}`,
                    confirmButtonText: `${i18n.t('continue')}`,
                    confirmButtonColor: '#E94981',
                    denyButtonText: `${i18n.t('dontCopy')}`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        this.setState({ disabled: false })
                        window.location.href = `/${this.state.empresaMapping}/standard${this.state.standardType}/certificateGenerator?userInfo=${this.state.userInfo}&idProducto=${this.state.idProducto}&ownerAddress=${ownerAddress}&certificadoId=${this.state.certificadoId}&isChecked=${this.state.isChecked}&userId=${this.state.userId}&email=${this.state.email}&certificadoName=${this.state.certificadoName}&userEmail=${this.state.userEmail}`;
                    } else if (result.isDenied) {
                        Swal.fire({
                            title: `${i18n.t('changesNotSaved')}`,
                            confirmButtonText: `${i18n.t('continue')}`,
                            confirmButtonColor: '#E94981',
                            icon: 'info',
                            iconColor: '#66C08B',
                            width: '560px',
                        })
                    }
                })

            }
           
           

        } catch (err) {
            this.setState({ errorMessage: err })
            Swal.fire({
                title: `${i18n.t('errorOccurred')}`,
                confirmButtonText: `${i18n.t('continue')}`,
                confirmButtonColor: '#E94981',
                icon: 'info',
                iconColor: '#66C08B',
                width: '560px',
            })

        } 
    }

    _getproofUWallet = async () => {
        var walletAddressInput = document.getElementById("walletAddress")

        if (walletAddressInput.value != "") {
            await this.setState({ isChecked: "false" })
            var corporativeWalletCheckBox = document.getElementById("corporativeWalletCheckBox")
            corporativeWalletCheckBox.checked = false

        } else {
            await this.setState({ isChecked: "true" })
        }

        var walletAddressInput = document.getElementById("walletAddress")
        if (this.state.isChecked == "true") {
            walletAddressInput.value = properties.proofUHostWallet;

        } else {
            document.getElementById("walletAddress")
            walletAddressInput.value = "";
        }
    }


    _cargarUsuario =  async (item) => {

       
        this.setState({usuarioRelleno: item});
        this.setState({userEmails: null});
        this.setState({showModal: false});
        const codigoPais = item.codigoPais;
        const matchPais = codigoPais.match(/^([A-Z]{3})$/); // Solo tres letras y nada más
        const matchPaisMulti = codigoPais.match(/^([A-Z]{3})(\d{0,2})$/);
        if (matchPais) {
            this.setState({
              codigoLetras: codigoPais ,
            });
            this.handleCountryChange(codigoPais)
          }
          if (matchPaisMulti) {
            this.setState({
              codigoLetras: matchPaisMulti[1],  // Las tres letras
              codigoNumero: matchPaisMulti[2] ,
         
            });
            this.handleCountryChange(matchPaisMulti[1])
          }



      }
  

    _autoCompleteMail = async (email)=>{
        let userMail = JSON.stringify({
            "email": email,
            "walletDir": ""
          });

          let userInfo;

            try {
                userInfo = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/autocomplete`, userMail, this.state.bearer);
            } catch (error) {
                console.error("Error al obtener la información del usuario:", error);

                Swal.fire({
                    title: `${i18n.t('errorOccurred')}`,
                    confirmButtonText: `${i18n.t('continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'error',
                    iconColor: '#66C08B',
                    width: '560px',
                });

                userInfo = {}; // En caso de error, se asigna un objeto vacío
            }


          if(userInfo.data != ""){
            this.setState({userEmails: userInfo.data});
          }else{
            Swal.fire({
                title: `${i18n.t('userNotFound')}`,
                confirmButtonText: 'Continue',
                confirmButtonColor: '#E94981',
                icon: 'info',
                iconColor: '#66C08B',
                width: '560px',
            })
            this.setState({userEmails: null});
          }
    }

    _createUserIfNotExists = async (nombre, apellido1, apellido2, email, documento, ownerAddress, idProducto, isChecked, codigoPais) => {
        Cookies.remove('usuario');
        let emailWrapper = JSON.stringify({
            "email": email, 
            "documento": documento,
        });
        let userExistsResponse;

            try {
                userExistsResponse = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUserByMailOrDocument`, emailWrapper, this.state.bearer);
                localStorage.setItem('usuarioCertificado', JSON.stringify(userExistsResponse.data));     
            } catch (error) {
                console.error("Error al verificar la existencia del usuario:", error);

                Swal.fire({
                    title: `${i18n.t('errorOccurred')}`,
                    confirmButtonText: `${i18n.t('continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'error',
                    iconColor: '#66C08B',
                    width: '560px',
                });

                userExistsResponse = {}; // En caso de error, se asigna un objeto vacío
            }
        
        if (userExistsResponse.status == 200 && userExistsResponse.data.length == 0 ) {
            let isActive = (isChecked == "true") ? false : true
            let data = JSON.stringify({
                "email": email,
                "activeUser": isActive,
                "nombre": nombre,
                "apellido1": apellido1,
                "apellido2": apellido2,
                "termsAndConditions": false,
                "documento": documento,
                "walletDir": ownerAddress,
                "proofUWallet": isChecked,
                "codigoPais": codigoPais,
                "userRol": {
                    "id": "2",
                    "rol": "USER"
                }
            });
    
            const userResponse = apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/guardar`, data, this.state.bearer) .then(userExistsResponse => {
                localStorage.setItem('usuarioCertificado', JSON.stringify(userResponse.data));
                Swal.fire(`${i18n.t('newUser')}`, '', 'success')
              })
              .catch(error => {
                console.error('Error al guardar el usuario:', error);
                Swal.fire({
                    title: `${i18n.t('userNotSaved')}`,
                    confirmButtonText: `${i18n.t('Continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'info',
                    iconColor: '#66C08B',
                    width: '560px',
                })
              });
            this._encryptUserInfo(nombre, apellido1, apellido2, documento, email, idProducto, document.getElementById("walletAddress").value)
        }else{
            userExistsResponse.data.codigoPais
            this.setState({userId: userExistsResponse.data.id})
            const codigoLetras = userExistsResponse.data.codigoPais.replace(/\d{0,3}$/, '');
            this.setState({codigoPais: codigoLetras});
            Swal.fire({
                icon: 'info',
                iconColor: "#66C08B",
                title: `${i18n.t('emailAlreadyRegistered')}<br>${i18n.t('continueWithThisUser')}`,
                showDenyButton: true,
                html: `   <style>
                    table {
                        width: 100%; /* Ensures the table uses the full width of the alert */
                        border-collapse: collapse; /* Neatly joins the borders */
                        background: #f8f8f8; /* Gives a subtle background color */
                        border-radius: 8px; /* Rounded corners for the table */
                        overflow: hidden; /* Ensures the border-radius clips the content */
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow around the table */
                    }
                    th, td {
                        padding: 12px 15px; /* Ample padding for table cells */
                        border-bottom: 1px solid #ddd; /* Light line below each row */
                    }
                    th {
                        background-color: #e94981; /* Vibrant pinkish-magenta background for the header */
                        color: white; /* White text for better readability */
                        font-size: 16px; /* Slightly larger text for headings */
                    }
                    td {
                        color: #333; /* Darker text color for better readability */
                        font-size: 14px; /* Standard text size */
                    }
                    tr:last-child td {
                        border-bottom: none; /* Removes border from the last row */
                    }
                    td:first-child {
                        text-align: right; /* Aligns the labels to the right */
                        font-weight: bold; /* Makes the labels bold */
                        background-color: #f0f0f0; /* Light grey background for labels */
                    }
                    td:last-child {
                        text-align: left; /* Ensures values are aligned to the left */
                        background-color: #f7f7f7; /* Lighter grey background for values, enhancing contrast */
                    }
                </style>


                <table class="cewy-table">
                    <thead>
                        <tr>
                            <th colspan="2">${i18n.t('Customer Information')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>${i18n.t('name')}:</td><td>${userExistsResponse.data.nombre}</td></tr>
                        <tr><td>${i18n.t('apellido1')}:</td><td>${userExistsResponse.data.apellido1}</td></tr>
                        <tr><td>${i18n.t('apellido2')}:</td><td>${userExistsResponse.data.apellido2}</td></tr>
                        <tr><td>${i18n.t('email')}:</td><td>${userExistsResponse.data.email}</td></tr>
                        <tr><td>${i18n.t('documento')}:</td><td>${userExistsResponse.data.documento}</td></tr>
                        <tr><td>${i18n.t('propietarioCarpeta')}:</td><td>${userExistsResponse.data.walletDir}</td></tr>
                          <tr><td>${i18n.t('country')}:</td><td>${codigoLetras}</td></tr>
                    </tbody>
                    </table>`,
                                confirmButtonText: `${i18n.t('continue')}`,
                                confirmButtonColor: "#E94981",
                                denyButtonColor: "#d33",
                                denyButtonText: `${i18n.t('changeUser')}`,
                                width: 600,
                                padding: "3em",
                                // color: "#716add",
                                background: "#fff url(/images/trees.png)"
                            }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                    if (nombre != userExistsResponse.data.nombre) {
                                        document.getElementById('nombreInput').value = userExistsResponse.data.nombre;
                                        nombre = userExistsResponse.data.nombre;
                                    }
                                    
                                    // Verificar si el primer apellido es diferente y actualizar el input si es necesario
                                    if (apellido1 != userExistsResponse.data.apellido1) {
                                        document.getElementById('apellido1Input').value = userExistsResponse.data.apellido1;
                                        apellido1 = userExistsResponse.data.apellido1;
                                    }
                                    
                                    // Verificar si el segundo apellido es diferente y actualizar el input si es necesario
                                    if (apellido2 != userExistsResponse.data.apellido2) {
                                        document.getElementById('apellido2Input').value = userExistsResponse.data.apellido2;
                                        apellido2 = userExistsResponse.data.apellido2;
                                    }
                                    
                                    // Verificar si el documento es diferente y actualizar el input si es necesario
                                    if (documento != userExistsResponse.data.documento) {
                                        document.getElementById('documentoInput').value = userExistsResponse.data.documento;
                                        documento = userExistsResponse.data.documento;
                                    }
                                    if (userExistsResponse.data.proofUWallet != isChecked) {
                                        var checkBoxValue = userExistsResponse.data.proofUWallet
                                        if (checkBoxValue == "true") {
                                            document.getElementById("corporativeWalletCheckBox").checked = true
                                            this.setState({ isChecked: "true" })

                                        } else {
                                            document.getElementById("corporativeWalletCheckBox").checked = false
                                            this.setState({ isChecked: "false" })

                                        }
                                        if (document.getElementById("corporativeWalletCheckBox").checked == true) {
                                            this.setState({ ownerAddress: properties.proofUHostWallet })
                                            var walletAddressInput = document.getElementById("walletAddress")
                                            walletAddressInput.value = properties.proofUHostWallet;

                                        } else {
                                            this.setState({ ownerAddress: userExistsResponse.data.walletDir })
                                            var walletAddressInput = document.getElementById("walletAddress")
                                            walletAddressInput.value = userExistsResponse.data.walletDir;
                                        }
                                    }
                                    localStorage.setItem('usuarioCertificado', JSON.stringify(userExistsResponse.data));
                                    this._encryptUserInfo(nombre, apellido1, apellido2, documento, email, idProducto, document.getElementById("walletAddress").value)
                                    
                                }
                                else if (result.isDenied) {
                                    Swal.fire({
                                        title: `${i18n.t('changesNotSaved')}`,
                                        confirmButtonText: 'Continue',
                                        confirmButtonColor: '#E94981',
                                        icon: 'info',
                                        iconColor: '#66C08B',
                                        width: '560px',
                                    })
                                }
                            })

                        }
        

    }

    constructor(props) {
        super(props)
        this.state = {
            account: "0x0",
            bearer: null,
            disabled: true, 
            contract: null,
            certificadoName: null,
            direccion: null,
            contractOwner: null,
            userInfo: null,
            idProducto: null,
            ownerAddress: null,
            isChecked: false,
            corporativeWallet: null,
            certificadoId: null,
            userRol: null,
            userId: null,
            email: null,
            userEmail: null,
            empresaMapping: null,
            campos: null,
            standardType: null,
            isRootDir:null,
            showModal: false,
            usuarioRelleno: null,
            userEmails: null,
            multiLanguajeCountry: false,
            idiomasDisponibles: null,
            codigoPais: "ESP",
            codigoLetras: null,  // Las tres letras
            codigoNumero: null,
            codigoIdioma: null
        }
    }

    render() {

        if (this.state.campos != null) {

            let idProducto = this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")

            return (
                <>
                <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />

<div className="cewy-main-content1">

    <h1 className="cewy-content-title">{i18n.t('userHashGenerator')}</h1>
    <button className="cewy-button-link cewy-button-left" onClick={() => window.location.href = `/listaEmpresas`}>
        {i18n.t('backToEnterprise')}
    </button>

    <button className="cewy-button-link cewy-button-right" onClick={() => this.setState({showModal: true})}>
        {i18n.t('loadUser')}
    </button>
    
    <form onSubmit={(event) => {
        event.preventDefault();
        const nombre = this.nombre.value;
        const surname1 = this.surname1.value;
        const surname2 = this.surname2.value;
        const email = this.email.value;
        const id = this.id.value;
        const idProducto = this.idProducto.value;
        const ownerAddress = this.ownerAddress.value;
        let codigoLetras;
        let codigoPais;
        codigoLetras = this.state.codigoPais;
        if(this.state.multiLanguajeCountry == "true"){
            codigoPais = this.state.codigoPais.concat(this.codigoIdioma.value);
        }else{
            codigoPais = this.state.codigoPais;
        }
        

        this._checkIfInfoCorrect(nombre, surname1, surname2, email, id, idProducto, ownerAddress, codigoPais, codigoLetras);
    }}>


            <div className="cewy-wallet-container1">
            <label className="cewy-input-label">{i18n.t('country')}</label>
            {this.state.usuarioRelleno == null ? (
                    <CountrySelect
                    value={this.state.codigoPais}
                    onChange={this.handleCountryChange} usuarioRelleno = {this.state.usuarioRelleno}
                  />
                    ) : (
                        <CountrySelect
                        value={this.state.codigoPais}
                        onChange={this.handleCountryChange}
                        usuarioRelleno = {this.state.usuarioRelleno}
                  />
                    
                    )} 

                    {this.state.multiLanguajeCountry == "true" && (
                                    <>
                                    <label className="cewy-label">
                                    {i18n.t('idioma')}
                                    </label>
                                    {this.state.codigoNumero == null ? (
                                            <select
                                                className="cewy-input"
                                                ref={(codigoIdioma) => (this.codigoIdioma = codigoIdioma)}
                                                disabled={this.state.usuarioRelleno != null} // Condición para deshabilitar
                                            >
                                                {this.state.idiomasDisponibles.map((idioma, index) => (
                                                <option key={idioma.id} value={idioma.id}>
                                                    {i18n.t(idioma.idioma)}
                                                </option>
                                                ))}
                                            </select>
                                            ) : (
                                            <select
                                                className="cewy-input"
                                                value={this.state.codigoNumero}
                                                ref={(codigoIdioma) => (this.codigoIdioma = codigoIdioma)}
                                                disabled={this.state.usuarioRelleno !== null} // Condición para deshabilitar
                                            >
                                                {this.state.idiomasDisponibles.map((idioma) => (
                                                <option key={idioma.id} value={idioma.id}>
                                                    {i18n.t(idioma.idioma)}
                                                </option>
                                                ))}
                                            </select>
                                            )}

                                    </>
                                )}

            </div>

        <div className="cewy-input-columns">
            <div className="cewy-column">
                <label className="cewy-input-label">{i18n.t('name')}</label>
                {this.state.usuarioRelleno == null ? <input type="text" id="nombreInput" className="cewy-input" ref={(nombre) => this.nombre = nombre} /> : 
                <input type="text" id="nombreInput" className="cewy-input" value={this.state.usuarioRelleno.nombre} ref={(nombre) => this.nombre = nombre} />}
                

                <label className="cewy-input-label">{i18n.t('apellido1')}</label>

                {this.state.usuarioRelleno == null ? <input type="text" id="apellido1Input" className="cewy-input" ref={(surname1) => this.surname1 = surname1} /> : 
                <input type="text" id="apellido1Input" className="cewy-input" value={this.state.usuarioRelleno.apellido1} ref={(surname1) => this.surname1 = surname1} />}
              
                <label className="cewy-input-label">{i18n.t('apellido2')}</label>
                {this.state.usuarioRelleno == null ? <input type="text" id="apellido2Input" className="cewy-input" ref={(surname2) => this.surname2 = surname2} />  : 
                <input type="text" id="apellido2Input" className="cewy-input" value={this.state.usuarioRelleno.apellido2} ref={(surname2) => this.surname2 = surname2} />}
                
                    

                
            </div>

            <div className="cewy-column">
                <label className="cewy-input-label">{i18n.t('email')}</label>
                {this.state.usuarioRelleno == null ?  <input type="text" id="emailInput" className="cewy-input" ref={(email) => this.email = email} />  : 
                 <input type="text" id="emailInput" className="cewy-input"  value={this.state.usuarioRelleno.email} ref={(email) => this.email = email} />
                }
                

               

                <label className="cewy-input-label">{i18n.t('documento')}</label>

                {this.state.usuarioRelleno == null ?   <input type="text" id="documentoInput" className="cewy-input" ref={(id) => this.id = id} /> : 
                 <input type="text" id="documentoInput" className="cewy-input" value={this.state.usuarioRelleno.documento} ref={(id) => this.id = id} />
                }

               

                <label className="cewy-input-label"> {i18n.t(this.state.campos.filter((campo) => campo.orden == "IDPRODUCTO")[0].nombreCampo)}</label>
                <input type="text" className="cewy-input" ref={(idProducto) => this.idProducto = idProducto} />
            </div>
        </div>

       

        <label className="cewy-input-label">{i18n.t('proofUWallet')}</label>
        {this.state.usuarioRelleno == null ?    <input type="checkbox"
                id="corporativeWalletCheckBox"
                name="topping"
                className='cewy-checkbox'
                value="Hold on corporative wallet"
                checked={this.state.isChecked}
                onChange={this._getproofUWallet} />: 
                <input type="checkbox"
                id="corporativeWalletCheckBox"
                name="topping"
                className='cewy-checkbox'
                value="Hold on corporative wallet"
                checked={this.state.usuarioRelleno.proofUWallet}
                onChange={this._getproofUWallet} />
                }
            
           
        <div className="cewy-wallet-container">



        {this.state.usuarioRelleno == null ?    <input type="text" className="cewy-inputAddress"
                placeholder={i18n.t('propietarioCarpeta')}
                id="walletAddress"
                ref={(ownerAddress) => this.ownerAddress = ownerAddress} /> : 
                <input type="text" className="cewy-inputAddress"
                placeholder={i18n.t('propietarioCarpeta')}
                id="walletAddress" value = {this.state.usuarioRelleno.walletDir}
                ref={(ownerAddress) => this.ownerAddress = ownerAddress} />
                }
        </div>

       
            <button text='Generate Number' className="cewy-centered-button" type='submit'>{i18n.t('userHash')}</button>
       
    </form>
</div>

<Footer />

    {this.state.showModal && (
        <div className="modal-overlay">
            <div className="modal-content">
                
                <label className="cewy-input-label">{i18n.t('email')}</label>
                <input type="email" className="modal-input" ref={(emailModal) => this.emailModal = emailModal} />
                <button className="modal-button" onClick={() => this._autoCompleteMail(this.emailModal.value)}>
                    {i18n.t('loadUser')}
                </button>


                <button className="modal-close" onClick={() => this.setState({ showModal: false })}>
                    {i18n.t('close')}
                </button>

                <UsuarioDisplay items = {this.state.userEmails} cargarUsuario={this._cargarUsuario} />
            </div>
        </div>
    )}




                </>
            );
        }

}
}
export default withTranslation()(PrivateKeyGenerator);
